import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getBusinessContext } from '@api';

export const getCoreBusinessContextSlice = createGetAsyncSlice({
	name: 'CoreBusinessContext',
	receive: true,
	request: true,
	requestHandler: getBusinessContext,
	retainDataOnRequest: false
});
